import React, { Component } from "react";
import { Accordion, Grid, Image } from 'semantic-ui-react';
import { MemoryRouter as Router, Route } from "react-router-dom";
import PanelHeader from "./components/PanelHeader/index";

var _ = require('lodash');

var defaultSection = document.getElementById("precag").getAttribute("data-default-section");
var jsonRoute = document.getElementById("precag").getAttribute("data-precag-component");

function isObject(value) {
    return value && typeof value === 'object' && value.constructor === Object;
}

class PrecAg extends Component {

    constructor(props) {
        super(props)
        this.state = { sectionMarkup: null }
        this.panel1 = React.createRef();
    }

    componentDidMount() {
        fetch(jsonRoute)
            .then(res => res.json())
            .then(data => {
                var sectionMarkup = [];  //Contains title of each main panel section
                // for (var i = 0; i < data.length; i++) {
                    
                    if(data){
                        _.forEach(data,(section, i) => {
                            if (!isObject(section))
                                return;
    
                            // var section = data[i];
    
                            var key = section.sectionType;
                            var panels = [];  //Contains title of each panel
    
                            var sc = section["sectionContent"];
                            // for (var j = 0; j < sc.length; j++) {
                            if (sc) {
                                _.forEach(sc,(obj, j) => {
                                    if (!isObject(obj))
                                        return;
                                    // var obj = sc[j];
    
                                    var ytLink = "https://www.youtube.com/embed/" + obj.vidID;
                                    var panelObj = {
                                        key: 'panel-' + key.toLowerCase().replace(" ", "") + "-" + j,
                                        title: obj.title,
                                        content: {
                                            content:
                                                <Grid columns={2} padded stackable>
                                                    <Grid.Row>
                                                        <Grid.Column>
                                                            <h2>{obj.title}</h2>
                                                            <p><span dangerouslySetInnerHTML={{ __html: obj.desc }}></span></p>
                                                            {(obj.links.length > 0) ? <p className="avail"><b>Available On: </b><span dangerouslySetInnerHTML={{ __html: obj.links }}></span></p> : ""}
                                                        </Grid.Column>
                                                        <Grid.Column>
                                                            {(obj.vidID.length > 0) ? <div className="embed-responsive embed-responsive-16by9"><iframe className="embed-responsive-item" src={ytLink} title="vid"></iframe></div> : <Image src={obj.imgURL} />}
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                        }
                                    }
                                    panels.push(panelObj);
                                });
    
                            }
    
                            var panelClass = "panel-" + key.toLowerCase().replace(" ", "");
                            var description = section.sectionDesc;
                            var accent = section.sectionAcc;
                            var sectionTitle = section.sectionLabel;
                            var sectionShowButton = {
                                "showMore": section.sectionShowMore,
                                "showLess": section.sectionShowLess
                            };
    
    
    
                            sectionMarkup.push(
                                <section>
                                    <Route
                                        path="/"//:panel?"
                                        component={props => {
                                            const params = new URLSearchParams(document.location.search); 
                                            const panel = params.get('panel');
                                            console.log("panel: "+ panel);

                                            //debugger;
                                        
                                            /* If there is a parameter */
                                            // if (props.match.params.panel === sectionTitle.toLowerCase().replace(" ", "")) {
                                            if (panel === sectionTitle.toLowerCase().replace(" ", "")) {
                                                return (
                                                    <PanelHeader panels={panels} state={true} className={panelClass} title={sectionTitle} type={key} desc={description} accent={accent} showButton={sectionShowButton}>
                                                        {({ truncatedPanels }) => <Accordion panels={truncatedPanels} fluid exclusive={true}></Accordion>}
                                                    </PanelHeader>
                                                );
                                                /* If there is no param, default to local storage */
                                            // } else if (localStorage.activePanel === sectionTitle.toLowerCase().replace(" ", "") && !props.match.params.panel) {
                                            } else if (localStorage.activePanel === sectionTitle.toLowerCase().replace(" ", "") && !panel) {

                                                return (
                                                    <PanelHeader panels={panels} state={true} className={panelClass} title={sectionTitle} type={key} desc={description} accent={accent} showButton={sectionShowButton}>
                                                        {({ truncatedPanels }) => <Accordion panels={truncatedPanels} fluid exclusive={true}></Accordion>}
                                                    </PanelHeader>
                                                );
                                                /* else default to default section */
                                            } else if (defaultSection === sectionTitle.toLowerCase().replace(" ", "") && !localStorage.activePanel && !panel) { //&& !props.match.params.panel) {
                                                return (
                                                    <PanelHeader panels={panels} state={true} className={panelClass} title={sectionTitle} type={key} desc={description} accent={accent} showButton={sectionShowButton}>
                                                        {({ truncatedPanels }) => <Accordion panels={truncatedPanels} fluid exclusive={true}></Accordion>}
                                                    </PanelHeader>
                                                );
                                            } else {
                                                return (
                                                    <PanelHeader panels={panels} state={false} className={panelClass} title={sectionTitle} type={key} desc={description} accent={accent} showButton={sectionShowButton}>
                                                        {({ truncatedPanels }) => <Accordion panels={truncatedPanels} fluid exclusive={true}></Accordion>}
                                                    </PanelHeader>
                                                );
                                            }
                                        }}
                                    />
                                </section>
                            );
    
                            // }
                        });
                    }
                    
                



                this.setState({ sectionMarkup: sectionMarkup });
            });

    }


    render() {
        if (this.state.sectionMarkup) {
            return <div>{this.state.sectionMarkup}</div>;
        }
        return <div>Loading...</div>;
    }
};

export default () => {
    return (
        <Router>
            <div>
                <PrecAg />
            </div>
        </Router>
    );
};


// WEBPACK FOOTER //
// ./src/App.js